export default "__VITE_ASSET__DB5uOcqU__"